var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.newItem ? 'background-color-green' : 'background-color-fire-engine-red',
    'color-white',
    'corner-ribbon',
    'font-weight-semibold',
    _vm.classes,
  ]},[_vm._v(" "+_vm._s(_vm.newItem ? "NEW" : "DEAL")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }